import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import CepPromise from 'cep-promise'; 
import { 
    ContainerModal,
    BoxModalCartao,
    InfoModalCartao,
    BoxFlexmodal,
    P1Modal,
    P9,
    ContainerButtomMobile,
    ContainerInfoScrooll
} from './PerfilPage.style.js';
import { 
    ContainerInputs,
    FlexTable,
    StyledInput,
    ButtonContinuarCompra,
    P5,P7,P8,
    FlexPolitica,
    FlexSecure
} from './Information.style.js';
import SairModal from '../components/svg/sairModal.svg';
import BaronTechSegura from '../components/assets/BaronTechSegura.png';
import GoogleLojaSegura from '../components/assets/GoogleLojaSegura.png';

const ModalEndereco = ({ isOpen, onClose }) => {
    // Estados do componente
    const [cep, setCep] = useState('');
    const [nome, setNome] = useState('');
    const [sobrenome, setSobrenome] = useState('');
    const [telefone, setTelefone] = useState('');
    const [bairro, setBairro] = useState('');
    const [rua, setRua] = useState('');
    const [numero, setNumero] = useState('');
    const [complemento, setComplemento] = useState('');
    const [cidade, setCidade] = useState('');
    const [estado, setEstado] = useState('');
    const [pais, setPais] = useState('Brasil');
    const [cpf, setCpf] = useState('');

    // Função para buscar o endereço
    const fetchAddress = async (cepValue) => {
        try {
            const address = await CepPromise(cepValue);
            setBairro(address.neighborhood || '');
            setRua(address.street || '');
            setCidade(address.city || '');
            setEstado(address.state || '');
            setPais('Brasil'); // Ajuste se necessário
        } catch (error) {
            console.error('Erro ao buscar o CEP:', error);
            // Você pode definir mensagens de erro aqui se desejar
        }
    };

    // Manipulador de mudança do CEP
    const handleCepChange = async (event) => {
        const value = event.target.value;
        setCep(value);

        if (value.length === 9) {
            await fetchAddress(value);
        }
    };

    // Renderização condicional
    if (!isOpen) return null;
    
    return (
        <ContainerModal onClick={onClose}>
            <BoxModalCartao onClick={e => e.stopPropagation()}>
                <BoxFlexmodal>
                    <div><P1Modal>Adicionar endereço</P1Modal></div>
                    <div>
                        <img 
                            style={{ cursor: 'pointer' }} 
                            src={SairModal} 
                            alt="Sair" 
                            onClick={onClose}  // Adiciona a funcionalidade de fechamento
                        />
                    </div>
                </BoxFlexmodal>
                <ContainerInfoScrooll>
                    <InfoModalCartao>
                        <div style={{width:'100%'}}>
                            <ContainerInputs style={{display:'flex', flexDirection:'column', gap:30, paddingBottom:30, borderBottom:'solid 1px #D2D2D2'}}>
                            <div><P9>Coloque as informações solicitadas abaixo para compras futuras você não <br/>
                            precisar mais digita-las.</P9></div>
                            <div>
                                <FlexTable>
                                    <StyledInput
                                        type="text"
                                        placeholder="Nome de quem irá receber (destinatário)"
                                        value={nome}
                                        onChange={(e) => setNome(e.target.value)}
                                        autoComplete="given-name" 
                                    />
                                </FlexTable>
                                <FlexTable>
                                    <InputMask 
                                        mask="99999-999" 
                                        value={cep} 
                                        onChange={handleCepChange}
                                        placeholder="CEP"
                                        maskChar={null}
                                    >
                                        {(inputProps) => <StyledInput {...inputProps} type="text" autoComplete="postal-code" />}
                                    </InputMask>
                                    <StyledInput 
                                        type="text" 
                                        placeholder="Número" 
                                        value={numero}
                                        onChange={(e) => setNumero(e.target.value)}
                                        autoComplete="address-line2" 
                                    />
                                    <StyledInput
                                        type="text"
                                        placeholder="Complemento"
                                        autoComplete="address-line2"
                                    />
                                </FlexTable>
                                <FlexTable>
                                    <StyledInput 
                                        type="text" 
                                        placeholder="Rua" 
                                        value={rua}
                                        onChange={(e) => setRua(e.target.value)}
                                        autoComplete="address-line1" 
                                    />
                                </FlexTable>
                                <FlexTable>
                                    <StyledInput 
                                        type="text" 
                                        placeholder="Bairro" 
                                        value={bairro}
                                        onChange={(e) => setBairro(e.target.value)}
                                        autoComplete="address-level2" 
                                    />
                                    <StyledInput 
                                        type="text" 
                                        placeholder="Cidade" 
                                        value={cidade}
                                        onChange={(e) => setCidade(e.target.value)}
                                        autoComplete="address-level2" 
                                    />
                                    <StyledInput 
                                        type="text" 
                                        placeholder="Estado" 
                                        value={estado}
                                        onChange={(e) => setEstado(e.target.value)}
                                        autoComplete="address-level1" 
                                    />
                                </FlexTable>
                            </div>
                            <ContainerButtomMobile>
                                <ButtonContinuarCompra><P5 style={{whiteSpace: 'nowrap'}}>Salvar endereço</P5></ButtonContinuarCompra>
                            </ContainerButtomMobile>
                        </ContainerInputs>
                    
                            <div>
                                <FlexPolitica>
                                    <P7>Política de frete</P7>
                                    <P7>Política de privacidade</P7>
                                    <P7>Termos de serviço</P7>
                                    <P7>Política de reembolso</P7>
                                </FlexPolitica>
                                <div>
                                    <div>
                                        <P8>Certificados</P8>
                                        <FlexSecure>
                                            <img style={{width: 60.667,height: 30.05}} src={BaronTechSegura}/>
                                            <img style={{width: 70, height: 23.81, marginLeft:10, border:'solid 1px #77B5E0'}} src={GoogleLojaSegura}/>
                                        </FlexSecure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </InfoModalCartao>
                </ContainerInfoScrooll>
            </BoxModalCartao>
        </ContainerModal>
    );
};

export default ModalEndereco;